// Copy: plans/portal-api/usg-eol-portal-notices-copy.txt, "COLLAPSED BANNERS" section
// (Dave-approved 2026-09-24, standalone-eol reworded 2026-10-15; do not reword). One-line summary shown while a collapsible
// NoticeBanner is collapsed.
import type { Notice, UsgService, StandaloneService, UispPhp2shellService } from '../../api/notices';

function usgEolSummary(services: UsgService[]): string {
  const uos = services.some((s) => s.platform === 'uos');
  const n = services.reduce((sum, s) => sum + s.usg_count, 0);
  const gatewayWord = n === 1 ? 'USG gateway' : 'USG gateways';

  if (services.length === 1) {
    const hostname = services[0].hostname;
    if (uos) {
      return `${n} ${gatewayWord} on ${hostname} will keep running but can't be managed once your console updates to Network 11.`;
    }
    return n === 1
      ? `${n} ${gatewayWord} on ${hostname} keeps working as it is. Plan to replace it before any move to UniFi OS Server reaches Network 11.`
      : `${n} ${gatewayWord} on ${hostname} keep working as they are. Plan to replace them before any move to UniFi OS Server reaches Network 11.`;
  }

  // Several services: N=1 across services cannot happen (each listed service has at least
  // one USG), so the plural wording below always applies.
  if (uos) {
    return `${n} ${gatewayWord} across your services will keep running but can't be managed once your consoles update to Network 11.`;
  }
  return `${n} ${gatewayWord} across your services keep working as they are. Plan to replace them before any move to UniFi OS Server reaches Network 11.`;
}

function standaloneEolSummary(services: StandaloneService[]): string {
  const selfServe = services.some((s) => s.migration_path === 'self_serve');
  return selfServe
    ? "Network 11 and later will only be available on UniFi OS Server. You can upgrade whenever you're ready, and most upgrades take 20 to 30 minutes."
    : 'Network 11 and later will only be available on UniFi OS Server. To upgrade, open your service and click Request Migration Access.';
}

// Copy: plans/portal-api/uisp-php2shell-portal-notice-copy.txt, "COLLAPSED BANNER".
function uispPhp2shellSummary(services: UispPhp2shellService[]): string {
  const where = services.length === 1 ? services[0].hostname : 'your services';
  return `The UISP CRM module on ${where} is restricted until Ubiquiti ships a PHP fix. Nothing is needed from you.`;
}

export function noticeSummary(notice: Notice): string {
  switch (notice.key) {
    case 'uisp-php2shell':
      return uispPhp2shellSummary(notice.data.services);
    case 'usg-eol':
      return usgEolSummary(notice.data.services);
    case 'standalone-eol':
      return standaloneEolSummary(notice.data.services);
    case 'stripe-billing':
      return "Switching takes about a minute, and any time you've already paid for carries over.";
    default:
      return '';
  }
}
